<template>
    <div class="pcoded-content mob" data-app>
        <link
            href="https://cdn.jsdelivr.net/npm/bootstrap@5.0.1/dist/css/bootstrap.min.css"
            rel="stylesheet"
            integrity="sha384-+0n0xVW2eSR5OomGNYDnhzAbDsOXxcvSN1TPprVMTNDbiYZCxYbOOl7+AMvyTG2x"
            crossorigin="anonymous"
        />
        <div class="row">
            <div class="col-lg-12 navigation">
                <div class="all">
                    <div
                        class="one"
                        :class="{ active: this.show == 1 }"
                        @click="show_Offer(1)"
                    >
                        <span>1.</span>
                        {{ $t('offer.step_basic') }}
                    </div>
                    <div
                        class="one"
                        :class="{ active: this.show == 2 }"
                        @click="show_Offer(2)"
                    >
                        <span>2.</span>
                        {{ $t('offer.step_items') }}
                    </div>
                    <div
                        class="one"
                        :class="{ active: this.show == 3 }"
                        @click="show_Offer(3)"
                    >
                        <span>3.</span>
                        {{ $t('offer.step_design') }}
                    </div>
                </div>
            </div>
        </div>
        <div class="page-header card" style="border: none">
            <div class="row align-items-end">
                <div class="col-lg-12 padding-none">
                    <div
                        class="page-header-title d-flex align-items-center w-100"
                    >
                        <div class="d-inline w-100">
                            <div
                                v-if="this.show == 2"
                                class="mobil_top d-flex w-100 justify-content-between align-content-center"
                            >
                                <h1>
                                    {{ main_data.nazov }}
                                </h1>
                                <a
                                    :href="
                                        '/' +
                                        uuid +
                                        '/' +
                                        offer_exam.slug +
                                        '/' +
                                        offer_exam.id
                                    "
                                    target="_blank"
                                    class="nahlad"
                                >
                                    <svg
                                        class="mr-2"
                                        width="24"
                                        height="24"
                                        viewBox="0 0 24 24"
                                        fill="none"
                                    >
                                        <path
                                            d="M1 12C1 12 5 4 12 4C19 4 23 12 23 12C23 12 19 20 12 20C5 20 1 12 1 12Z"
                                            stroke="#2ED8B6"
                                            stroke-width="2"
                                            stroke-linecap="round"
                                            stroke-linejoin="round"
                                        />
                                        <path
                                            d="M12 15C13.6569 15 15 13.6569 15 12C15 10.3431 13.6569 9 12 9C10.3431 9 9 10.3431 9 12C9 13.6569 10.3431 15 12 15Z"
                                            stroke="#2ED8B6"
                                            stroke-width="2"
                                            stroke-linecap="round"
                                            stroke-linejoin="round"
                                        />
                                    </svg>
                                    {{ $t('offer.preview') }}
                                </a>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="pcoded-inner-content">
            <div class="main-body">
                <div class="page-wrapper">
                    <div class="page-body">
                        <offer-one
                            ref="offer_one"
                            v-show="this.show == 1"
                            :main_data="main_data"
                            :personinfo="personInfo"
                            :options="edit_entries.offerData"
                            :premium="premium"
                            :mojefirmy="mojefirmy"
                            :uuidOffer="uuid"
                            :user_template="user_template"
                            :status_offer="status_offer"
                            :currency_data="main_data.currency"
                            :preloadedfiles="preloadedfiles"
                            :preloadedofferfiles="preloadedofferfiles"
                            :new_offer="new_offer"
                            :offer_legend="offer_legend"
                            :props_zdroj_kontaktu="props_zdroj_kontaktu"
                            :is_paid="is_paid"
                            @offerExam="offer_exam = $event"
                            @saveAndCont="mainData($event)"
                        ></offer-one>
                        <offer-two
                            ref="offer_two"
                            v-show="this.show == 2"
                            :TotalPrice="price"
                            :edit_entries="edit_entries"
                            :koncept="koncept"
                            :uuidOffer="uuid"
                            :dph="dph"
                            :new_offer="new_offer"
                            :premium="premium"
                            :showStatus="this.show"
                            :preloadedentrytitlephoto="preloadedentrytitlephoto"
                            :preloadedentrytitlephoto_mobile="
                                preloadedentrytitlephoto_mobile
                            "
                            :default_dph_="default_dph"
                            :is_paid="is_paid"
                            :createdByAi="created_by_ai"
                            :aiEstimatedCount="ai_estimated_count"
                            :aiTotalCount="ai_total_count"
                            @back="back($event)"
                            @saveAndCont="entryData($event)"
                            @setPrice="price = $event"
                            @getEntires="entries = $event"
                            @preview="preview()"
                            @downloadPdf="downloadPdf()"
                        ></offer-two>
                        <offer-three
                            v-show="this.show == 3"
                            :uuidOffer="uuid"
                            :premium="premium"
                            :styleRowsProps="styleRows"
                            :celkovaCena="price"
                            :entries="entries"
                            :personInfo="personInfo"
                            :new_offer="new_offer"
                            :user_template="user_template"
                            :offer_exam="offer_exam"
                            :preloadedoffertitlephoto="preloadedoffertitlephoto"
                            :preloadedoffertitlephoto_mobile="
                                preloadedoffertitlephoto_mobile
                            "
                            :overlay-desktop="overlayDesktop"
                            :overlay-mobile="overlayMobile"
                            @back="back($event)"
                        ></offer-three>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
/*------- import ----------*/
import info from "./components/info.json";
import OfferOne from "./OfferOne.vue";
import OfferTwo from "./OfferTwo.vue";
import OfferThree from "./OfferThree.vue";
import { EventBus } from './components/EventBus';
export default {
    props: [
        "uuidoffer",
        "dph",
        "mojefirmy",
        "default_firma",
        "user_template",
        "preloadedofferfiles",
        "preloadedfiles",
        "preloadedoffertitlephoto",
        "preloadedoffertitlephoto_mobile",
        "overlayDesktop",
        "overlayMobile",
        "preloadedentrytitlephoto",
        "preloadedentrytitlephoto_mobile",
        "offer_legend",
        "props_zdroj_kontaktu",
        "user",
        "is_paid",
        "created_by_ai",
        "ai_estimated_count",
        "ai_total_count"
    ],
    components: { OfferOne, OfferTwo, OfferThree },
    data() {
        return {
            uuid: "",
            status_offer: 1,
            show: 1,
            price: null,
            main_data: {},
            edit_entries: {
                offerData: {},
                new_entries: [],
            },
            entries: [],
            offer_exam: {},
            personInfo: {
                osoba: "",
                email: "",
                cislo: "",
                firemne_udaje: "",
            },
            styleRows: [],
            left_menu: true,
            firma: {},
            premium: {},
            new_offer: false,
            first_time_saved: false,
            koncept: 0,
            default_dph: "",
        };
    },
    created() {
        var t = this;
        axios
            .post(`/api/offers/${this.uuidoffer}`)
            .then((response) => {
                if(response.data == "new offer"){
                    t.new_offer = true;
                    t.uuid = t.makeuuid(6);
                    t.getPersonalInfo();
                    t.main_data = {
                        id_klient: 0,
                        nazov: "",
                        verejny_nazov: this.$t ? this.$t('offer.default_title') : 'Cenová ponuka',
                        user_provided_id: "",
                        mojafirma: "",
                        mojafirma_nazov: t.default_firma,
                        platnost: null,
                        datum_vystavenia: null,
                        text: "",
                        lang: "sk",
                    };
                }else{
                    t.uuid = t.uuidoffer;
                    t.makeData(response.data);
                    t.firma = response.data.firma;
                    t.new_offer = false;
                    t.first_time_saved = true
                }
            })
            .catch(function (error) {
                console.error(error);
            });
        if (localStorage.edit_polozka == "success") {
            this.show = 2;
            localStorage.removeItem("edit_polozka");
        }
        axios.get(`/api/premium`).then((response) => {
            t.premium = response.data;
        });
    },
    mounted() {
        localStorage.setItem("menu", "roll");
        $(".menuleft").addClass("hide");
        $(".pcoded-content").addClass("hide");
        this.findDefaultCompany
        if (this.user && this.user.seen_video) {
            EventBus.$emit('seenVideo', this.user.seen_video);
        }
        EventBus.$emit('is_paid', this.is_paid);
    },
    methods: {
        preview(){
            window.open(`/${this.uuid}/${this.offer_exam.slug}/${this.offer_exam.id}`, '_blank');
        },
        downloadPdf(){
            var link = document.createElement("a");
            link.href = `/pdf/${this.uuid}/${this.offer_exam.slug}/${this.offer_exam.id}`;
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
        },
        entryData(value) {
            this.show = 3;
            if (this.show > this.status_offer) {
                if (this.status_offer != 0) {
                    axios
                        .post(`/api/offers/offer/status/save`, {
                            uuid: this.uuid,
                            status_offer: 3,
                        })
                        .then((response) => {});
                }
                this.status_offer = this.show;
                $("html,body").scrollTop(0);
            }
        },
        mainData(value) {
            this.main_data = value;
            this.show = 2;
            if(this.$refs.offer_two.entries.length == 0) {
                this.$refs.offer_two.createEmptyEntry();
            }
            if (this.show > this.status_offer) {
                if (this.status_offer != 0) {
                    axios
                        .post(`/api/offers/offer/status/save`, {
                            uuid: this.uuid,
                            status_offer: 2,
                        })
                        .then((response) => {});
                }
                this.status_offer = this.show;
            }
        },
        back(id) {
            this.show = id;
            $("html,body").scrollTop(0);
        },
        show_Offer(id) {
            if(id == 2) {
                if(this.$refs.offer_two.entries.length == 0) {
                    this.$refs.offer_two.createEmptyEntry();
                }
            }
            if(this.$refs.offer_one.readyToSave())
                this.show = id;
            if(id != 1 && !this.first_time_saved){
                this.$refs.offer_one.ulozit(-1)
                this.first_time_saved = true
            }
        },
        makeData(data) {
            this.status_offer = data.offer.koncept;
            this.koncept = data.offer.koncept;
            this.main_data = {
                id_klient: data.offer.klient_id,
                nazov: data.offer.nazov,
                verejny_nazov: data.offer.verejny_nazov,
                user_provided_id: data.offer.user_provided_id,
                platnost: data.offer.datum,
                datum_vystavenia: data.offer.datum_vystavenia,
                text: data.offer.text,
                mojafirma: data.offer.mojafirma,
                mojafirma_nazov: data.offer.mojafirma
                    ? data.offer.mojafirma.nazov
                    : this.default_firma,
                udaje_klienta_lavo: data.offer.udaje_klienta_lavo,
                udaje_klienta_pravo: data.offer.udaje_klienta_pravo,
                lang: data.offer.lang,
                currency: data.offer.currency,
            };
            this.edit_entries.offerData = {
                confirmed_status: data.offer.confirmed_status,
                reviews: data.offer.reviews,
                dodanie: data.offer.dodanie,
                dodanie_text: data.offer.dodanie_text,
                zlava: data.offer.zlava,
                dph: data.offer.dph,
                show_price_box: !data.offer.show_price_box,
            };
            this.personInfo = {
                osoba: data.offer.osoba,
                email: data.offer.email,
                cislo: data.offer.cislo,
                firemne_udaje: data.offer.firemne_udaje,
            };
            this.makeEntries(data);
            this.styleRows = {
                price_rows: data.price_rows,
                isRows: data.offer.isRows,
                dark: data.offer.style,
                color: data.offer.color,
                compact_version: data.offer.compact_version,
                footer_logo: data.offer.footer_logo,
                template_type: data.offer.template_type,
            };
            this.offer_exam["id"] = data.id;
            this.offer_exam["slug"] = data.slug;
        },
        makeEntries(data) {
            data.entries.forEach((entry) => {
                let one = {
                    uuid: entry.uuid == "" ? this.makeuuid(6) : entry.uuid,
                    id: entry.id,
                    name: entry.nazov,
                    text: entry.text,
                    files: entry.files,
                    inter_note:
                        entry.inter_note == null ? "" : entry.inter_note,
                    type: parseInt(entry.type_cena),
                    discount_type: entry.discount_type,
                    dph: entry.dph,
                    values: {
                        number_of:
                            entry.pocet_hodin == null
                                ? 0
                                : parseFloat(entry.pocet_hodin),
                        number_of_to:
                            entry.pocet_hodin_do == null ? 0 : parseFloat(entry.pocet_hodin_do),
                        tariff:
                            entry.hodinova_sadzba == null ? 0 : parseFloat(entry.hodinova_sadzba),
                        price_from: 0,
                        price_to: this.setPrice(entry.cena_do_without_discount, entry, true),
                        auto_price: this.setPrice(entry.cena, entry),
                        own_price: this.setPrice(entry.cena_without_discount, entry),
                        from_to_price: 0,
                        discount: entry.zlava == null ? 0 : parseFloat(entry.zlava),
                    },
                    exclude: entry.nezobrazovat_cena,
                    subEntries: [],
                };
                one["unit"] = entry.jednotka;
                if (entry.type_cena == 2) {
                    if (entry.jednotka == null) 
                        one["unit"] = "";

                    one["isOwnPrice"] = false;
                }
                if (entry.type_cena == 1) {
                    one.values.price_from = this.setPrice(entry.cena_without_discount, entry);
                    one.values.from_to_price = entry.cena_without_discount + " - " + entry.cena_do;
                }
                data.subentries.forEach((subentry) => {
                    if (subentry.entry_id == entry.id) {
                        let sub = {};
                        sub["id"] = subentry.line;
                        sub["uuid"] = this.makeuuid(6);
                        sub["component"] = null;

                        let two = {
                            name: subentry.nazov_polozka,
                            text: subentry.text_polozka,
                            type: info.types[
                                parseInt(subentry.type_cena_polozka)
                            ],
                            dph: subentry.dph_polozka,
                            values: {
                                number_of:
                                    subentry.hodiny_polozka == null
                                        ? 0
                                        : parseFloat(subentry.hodiny_polozka),
                                number_of_to:
                                    subentry.hodiny_do_polozka == null
                                        ? 0
                                        : parseFloat(
                                              subentry.hodiny_do_polozka
                                          ),
                                tariff:
                                    subentry.sadzba_polozka == null
                                        ? 0
                                        : parseFloat(subentry.sadzba_polozka),
                                price_from: 0,
                                price_to:
                                    subentry.cena_do_polozka == null
                                        ? 0
                                        : parseFloat(subentry.cena_do_polozka),
                                auto_price:
                                    subentry.cena_polozka == null
                                        ? 0
                                        : parseFloat(subentry.cena_polozka),
                                own_price:
                                    subentry.cena_polozka == null
                                        ? 0
                                        : parseFloat(subentry.cena_polozka),
                                from_to_price: 0,
                                discount:
                                    subentry.zlava_polozka == null
                                        ? 0
                                        : parseFloat(subentry.zlava_polozka),
                            },
                            exclude: subentry.nezobrazovat_cena_polozka,
                        };
                        two["unit"] = subentry.jednotka_polozka;
                        if (subentry.type_cena_polozka == 2) {
                            if (subentry.jednotka_polozka == null)
                                two["unit"] = "null";
                            two["isOwnPrice"] = false;
                        }
                        if (subentry.type_cena_polozka == 1) {
                            two.values.price_from =
                                subentry.cena_polozka == null
                                    ? 0
                                    : parseFloat(subentry.cena_polozka);
                            two.values.from_to_price =
                                subentry.cena_polozka +
                                " - " +
                                subentry.cena_do_polozka;
                        }
                        sub["data"] = two;
                        one.subEntries.push(sub);
                    }
                });
                this.edit_entries.new_entries.push(one);
            });
        },
        setPrice(price, entry, is_to = false){
            if(price == null) return 0;
            let _price = is_to ? entry.cena_do_without_discount : entry.cena_without_discount;
            if(price <= 0) return parseFloat(_price);
            return parseFloat(price);
        },
        makeuuid(length) {
            var result = "";
            var characters =
                "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";
            var charactersLength = characters.length;
            for (var i = 0; i < length; i++) {
                result += characters.charAt(
                    Math.floor(Math.random() * charactersLength)
                );
            }
            return result;
        },
        getPersonalInfo() {
            axios.get("/api/user").then((response) => {
                this.personInfo.osoba = response.data.company.ko_meno;
                this.personInfo.email = response.data.company.ko_email;
                this.personInfo.cislo = response.data.company.ko_tel;
                this.personInfo.firemne_udaje = this.transformFiremneUdaje(
                    response.data.user
                );
            });
            this.findDefaultCompany
        },
        transformFiremneUdaje(user) {
            var res = "";
            if (user.fa_company != null) res += user.fa_company + "\n";
            if (user.fa_address != null) res += user.fa_address + "\n";
            if (user.fa_psc != null) res += user.fa_psc + " ";
            if (user.fa_town != null) res += user.fa_town;
            return res;
        },
    },
    watch: {
        "main_data.mojafirma": function () {
            if(this.main_data.mojafirma && this.new_offer){
                this.default_dph = this.main_data.mojafirma.dph;
            }
        }
    }
};
</script>
<style lang="scss" scoped>
.pcoded-content {
    background-color: #fff;
}

h1 {
    font-style: normal;
    font-weight: 500;
    font-size: 36px;
    line-height: 45px;
    color: #212541;
    @media (max-width: 600px) {
        font-size: 24px;
        line-height: 30px;
    }
}
.mobil_top {
    @media (max-width: 1200px) {
        display: grid !important;
    }
    @media (max-width: 600px) {
        margin-left: 10px !important;
    }
    h1 {
        @media (max-width: 1200px) {
            text-align: left;
        }
    }
}
.nahlad {
    font-family: Roboto;
    font-style: normal;
    font-weight: bold;
    font-size: 16px;
    line-height: 20px;
    display: flex;
    align-items: center;
    text-align: center;
    color: #2ed8b6;
    text-decoration: none;
    @media (max-width: 1200px) {
        margin: 10px 0;
    }
}
.alert-success {
    padding: 11px;
    height: auto;
    display: flex;
    align-items: center;
    justify-content: space-between;
    color: #0f5132;
    background-color: white;
    border-color: #2ed8b6;
    p {
        font-weight: 500;
        color: #2ed8b6;
        a {
            color: #2ed8b6;
            &:hover {
                color: #2ed8b6;
                text-decoration: underline;
            }
        }
    }
    button {
        margin: 0;
    }
}

.spat {
    margin-top: 23px;
    width: 131px;
    height: 30px;
    background: #d9e5ee;
    border: none;
    border-radius: 3px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 0 10px;
    font-family: Quicksand;
    font-style: normal;
    font-weight: 600;
    font-size: 16px;
    line-height: 20px;
    color: #263544;
    cursor: pointer;
    img {
        transform: translateX(5px);
        transition: all 0.5s ease-in-out;
    }
    &:hover {
        background: #cadbe7;
        img {
            transform: translateX(0px);
        }
    }
    &:focus {
        outline: none;
    }
}
.pcoded-inner-content {
    padding-top: 0px;
}
.main-body .page-wrapper {
    padding-top: 0px;
    @media (max-width: 1200px) {
        padding: 0.6rem 0.5rem;
    }
}
.page-header.card {
    margin: 16px 35px 0 35px;
}
.icon_plus_offer {
    margin-right: 11px;
    width: 29px;
    background: #263544;
    border-radius: 3px;
    display: flex;
    justify-content: center;
    align-items: center;
    padding: 7px 0 7px 0;
    img {
        @media (max-width: 786px) {
            width: 11px;
        }
    }
}
* {
    font-family: "Quicksand", sans-serif;
}
.navigation {
    background: rgba(38, 53, 68, 0.1);
}
.all {
    padding: 18px 0 18px 40px;
    display: flex;
    align-items: center;
    @media only screen and (max-width: 1100px) {
        padding: 0px 0 0px 18px;
        display: block;
    }
}
.one {
    cursor: pointer;
    display: flex;
    align-items: center;
    font-style: normal;
    font-weight: 600;
    font-size: 15px;
    line-height: 17px;
    color: #263544;
    margin-right: 20px;
    @media only screen and (max-width: 1100px) {
        padding: 5px;
    }
}
.one span {
    width: 20px;
    height: 20px;
    border-radius: 50%;
    background: #212541;
    display: flex;
    align-items: center;
    justify-content: center;
    color: #fff;
    margin-right: 10px;
    font-style: normal;
    font-weight: 600;
    font-size: 11px;
    line-height: 13px;
}
.one.active {
    color: #f3385a;
}
.one.active span {
    background: #f3385a;
}
.mob {
    margin-left: 60px !important;
    @media only screen and (max-width: 992px) {
        margin-left: 0 !important;
    }
}
.padding-none {
    @media (max-width: 1200px) {
        padding-left: 0 !important;
        padding-right: 0 !important;
    }
}
</style>

<style>
body {
    overflow: unset !important;
}
</style>
